<template>
  <button class="btn-animation" @click="tryOn">
    <div class="btn-inside">
      <!-- <go-icon style="fontSize: 32px;" /> -->
      <img alt="" height="16" :src="webcamOpened ? 'images/ic_round-360.svg' : 'images/ic_go.svg'" />
      <span class="title">{{ webcamOpened ? "360° Viewer" : "Try-on" }}</span>
    </div>
  </button>
</template>

<script>
// import { GoIcon } from "../Icons";

export default {
  props: ["webcamOpened"],
  components: {
    // GoIcon
  },
  methods: {
    tryOn() {
      this.$emit("try-on");
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes bounce {
  from,
  20%,
  53%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(0.95);
  }

  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.85);
  }

  90% {
    transform: translate3d(0, -4px, 0) scaleY(0.92);
  }
}

// .bounce {
//   animation-name: bounce;
//   transform-origin: center bottom;
// }

// .btn-animation {
//   animation-name: bounce;
//   animation-duration: 4s;
//   animation-delay: 10s;
//   animation-iteration-count: infinite;
//   transform-origin: center bottom;
// }

.btn-inside {
  display: flex;
  justify-content: center;
  align-items: center;
}

button {
  background-color: white;
  border: 2px solid #2f80ed;
  border-radius: 80px;
  text-align: center;
  // width: 140px;
  height: 40px;
  padding: 0 15px;
  transition: all 0.5s;
  outline: none;
  cursor: pointer;

  .title {
    display: inline-block;
    color: #2f80ed;
    margin-left: 8px;
    font-size: 1rem;
    font-weight: 500;
  }
}
</style>
